export default "__VITE_ASSET__4bd48c16__"